import { BaSeTheme } from '@base/react';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const HeaderAmei = styled.div`
  width: 100%;
  display: flex;
  justify-content: start;
  max-width: ${BaSeTheme.breakpoints.desktop.minWidth}px;
`;

export const ContentWrapper = styled.div`
  background-color: ${BaSeTheme.colors.defaultColors.white};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: ${BaSeTheme.stackOrder.normal};
  width: 100%;
  height: 100vh;
`;

export const Content = styled.div`
  max-width: ${BaSeTheme.breakpoints.desktop.minWidth}px;
  width: 100%;
  height: 100vh;

  button {
    margin: 24px 0 0 16px;
  }
`;

export const BoxIframe = styled.div`
  width: 100%;
  height: 92%;
  iframe {
    width: 100%;
    height: 100%;
  }
`;
